import { render, staticRenderFns } from "./ImageBackground.vue?vue&type=template&id=64083d9b&scoped=true"
import script from "./ImageBackground.vue?vue&type=script&lang=js"
export * from "./ImageBackground.vue?vue&type=script&lang=js"
import style0 from "./ImageBackground.vue?vue&type=style&index=0&id=64083d9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64083d9b",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonsNuxtImage: require('/app/components/Commons/NuxtImage.vue').default})
